import React from "react";
import { Redirect } from "react-router-dom";
import RiskDashboard from "./components/RiskDashboard";
import RiskDetail from "./components/RiskDetail";

const BASE_PATH = "/miscellaneous/risk-stratification";
const DETAIL_PREFIX = `${BASE_PATH}/details/`;

class RiskStratification extends React.Component {
  state = {
    // Detail page calls markDashboardDirty() on a successful save. When the
    // user returns to the dashboard we bump refreshToken so the dashboard
    // refetches with its current filters intact (avoiding stale rows).
    dashboardDirty: false,
    refreshToken: 0,
  };

  getPathname = (p) =>
    p.location?.pathname || p.history?.location?.pathname || "";

  componentDidUpdate(prevProps) {
    const prevPath = this.getPathname(prevProps);
    const curPath = this.getPathname(this.props);
    if (prevPath === curPath) return;

    const wasDetail = prevPath.startsWith(DETAIL_PREFIX);
    const isDetailNow = curPath.startsWith(DETAIL_PREFIX);
    if (wasDetail && !isDetailNow && this.state.dashboardDirty) {
      this.setState((s) => ({
        refreshToken: s.refreshToken + 1,
        dashboardDirty: false,
      }));
    }
  }

  markDashboardDirty = () => {
    this.setState({ dashboardDirty: true });
  };

  render() {
    const pathname = this.getPathname(this.props);
    const rest = pathname.replace(BASE_PATH, "").split("/").filter(Boolean);

    // Bare /miscellaneous/risk-stratification → land on dashboard.
    if (rest.length === 0) {
      return <Redirect to={`${BASE_PATH}/dashboard`} />;
    }

    const isDetail = rest[0] === "details";
    const detailId = isDetail ? rest[1] : null;

    return (
      <div style={{ height: "100%", width: "100%" }}>
        {/* Dashboard stays mounted across navigation so filter state survives. */}
        <div
          style={{
            height: "100%",
            width: "100%",
            display: isDetail ? "none" : "block",
          }}
        >
          <RiskDashboard
            history={this.props.history}
            refreshToken={this.state.refreshToken}
          />
        </div>
        {isDetail && (
          <RiskDetail
            history={this.props.history}
            data={{ id: detailId }}
            markDashboardDirty={this.markDashboardDirty}
          />
        )}
      </div>
    );
  }
}

export default RiskStratification;
